import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import './Navbar.css';
import logo from '../logo.png';

export default function Navbar() {
	const [scrolled, setScrolled] = useState(false);
	const [menuOpen, setMenuOpen] = useState(false);

	useEffect(() => {
		const onScroll = () => setScrolled(window.scrollY > 20);
		window.addEventListener('scroll', onScroll);
		return () => window.removeEventListener('scroll', onScroll);
	}, []);

	const navLinks = [
		{ label: 'Services', to: 'services' },
		{ label: 'About', to: 'about' },
		{ label: 'Contact', to: 'contact' },
	];

	return (
		<nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
			<div className='navbar__inner'>
				<div className='navbar__brand'>
					<img
						style={{
							height: 40,
						}}
						src={logo}
						alt='Apiary Consulting logo'
					/>
				</div>

				<div
					className={`navbar__links ${menuOpen ? 'navbar__links--open' : ''}`}
				>
					{navLinks.map(({ label, to }) => (
						<Link
							key={to}
							to={to}
							smooth={true}
							duration={500}
							offset={-60}
							className='navbar__link'
							onClick={() => setMenuOpen(false)}
						>
							{label}
						</Link>
					))}
					<Link
						to='contact'
						smooth={true}
						duration={500}
						offset={-60}
						className='navbar__cta'
						onClick={() => setMenuOpen(false)}
					>
						Get a quote →
					</Link>
				</div>

				<button
					className='navbar__burger'
					onClick={() => setMenuOpen((o) => !o)}
					aria-label='Toggle menu'
				>
					<span />
					<span />
					<span />
				</button>
			</div>
		</nav>
	);
}
